import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-687dccbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = ["href"]


import { PhoneOutlined } from '@ant-design/icons-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DeliveryContractorsRow',
  props: {
  label: String,
  contractors: Array
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, { class: "delivery-contractors-row no-mb" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, {
        xs: {span: 24},
        sm: {span: 24},
        md: {span: 24},
        lg: {span: 8}
      }, {
        default: _withCtx(() => [
          _createElementVNode("label", null, _toDisplayString(props.label), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_a_col, {
        xs: {span: 24},
        sm: {span: 24},
        md: {span: 24},
        lg: {span: 16}
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.contractors, (c, i) => {
            return (_openBlock(), _createElementBlock("p", {
              class: _normalizeClass(props.contractors.length - 1 === i ? 'no-mb' : ''),
              style: {"line-height":"2"},
              key: c.id
            }, [
              _createTextVNode(_toDisplayString(c.full_name), 1),
              _hoisted_1,
              _createTextVNode(" " + _toDisplayString(c.address), 1),
              _hoisted_2,
              _createTextVNode(" " + _toDisplayString(c.zipcode) + " " + _toDisplayString(c.city) + " ", 1),
              (c.phone)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_3,
                    _createElementVNode("a", {
                      href: 'tel:' + c.phone
                    }, _toDisplayString(c.phone), 9, _hoisted_4)
                  ], 64))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})